export const FLAG_GETTING_TOLL_LIQUIDATIONS = 'FLAG_GETTING_TOLL_LIQUIDATIONS';
export const GET_TOLL_LIQUIDATIONS = 'GET_TOLL_LIQUIDATIONS';
export const CLEAR_TOLL_LIQUIDATIONS = 'CLEAR_TOLL_LIQUIDATIONS';
export const FLAG_TOLL_LIQUIDATION_ACTIVITY = 'FLAG_TOLL_LIQUIDATION_ACTIVITY';
export const GET_TOLL_LIQUIDATION = 'GET_TOLL_LIQUIDATION';
export const CLEAR_TOLL_LIQUIDATION = 'CLEAR_TOLL_LIQUIDATION';
export const GET_ITINERARY_TOLL_LIQUIDATION = 'GET_ITINERARY_TOLL_LIQUIDATION';
export const CLEAR_ITINERARY_TOLL_LIQUIDATION =
  'CLEAR_ITINERARY_TOLL_LIQUIDATION';
export const GET_ITINERARY_TOLL_LIQUIDATION_DETAIL =
  'GET_ITINERARY_TOLL_LIQUIDATION_DETAIL';
export const CLEAR_ITINERARY_TOLL_LIQUIDATION_DETAIL =
  'CLEAR_ITINERARY_TOLL_LIQUIDATION_DETAIL';
export const FLAG_ITINERARY_TOLL_LIQUIDATION_DETAIL_ACTIVITY =
  'FLAG_ITINERARY_TOLL_LIQUIDATION_DETAIL_ACTIVITY';
export const FLAG_GETTING_TOLL_LIQUIDATION_DIFFENCE_REASONS =
  'FLAG_GETTING_TOLL_LIQUIDATION_DIFFENCE_REASONS';
export const GET_TOLL_LIQUIDATION_DIFFENCE_REASONS =
  'GET_TOLL_LIQUIDATION_DIFFENCE_REASONS';
